/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneMostRead from 'base/components/standalone/MostRead';

export const DynamicStandaloneMostRead = StandaloneMostRead;
export type DynamicStandaloneMostReadProps = PropsFromComponent<typeof StandaloneMostRead>;

export const DynamicStandaloneMostReadWith = (extras: DynamicStandaloneExtras): typeof StandaloneMostRead => {
    return function DynamicStandaloneMostRead(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'MostRead');
        return <StandaloneMostRead {...mergeProps({ options: { theme } }, props)} />;
    }
}